<div ng-click="vm.onCardClicked()" class="sub-item-card">
    <div class="menu-item-text">
        <span class="sub-item-label w-100">{{ label | translate }} </span>
        <span ng-if="description" style="line-height: 16px;" class="f-14 d-block sub-item-description" ng-bind-html="description"></span>
    </div>
    <span ng-if="icon" ng-class="icon"></span>
</div>
